import React from 'react';
export const CTAButton = () => {
  return <div className="my-6 text-center" data-id="element-225">
      <a href="https://www.tryglisera.com/products/glisera-anti-cellulite-oil" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-md shadow-lg transition duration-300 text-lg w-full md:w-auto uppercase" data-id="element-226">
        Apply Discount & Check Availability
      </a>
    </div>;
};